var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overlay d-flex flex-column"},[_vm._m(0),_c('div',[_c('h1',{staticClass:"white--text text-center mt-14 title msg"},[_vm._v(" "+_vm._s(_vm.msg)+" ")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"loader"},[_c('img',{attrs:{"width":"200","src":require("../../../public/playground_assets/Eleven_Tickets_Positivo_Vertical.svg")}})])
}]

export { render, staticRenderFns }